import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AgentCommission`;

const headers = {
  "Content-Type": "multipart/form-data"
}

const ApiAgentCommission = {
  getAllAgentCommissions: (params) => {
    const url = `${baseServiceUrl}/GetAllAgentCommissions`;
    return ServiceApi.get(url, { params });
  },
  getAllAgentCommissionsWithoutPagination: () => {
    const url = `${baseServiceUrl}/GetAgentCommissions`;
    return ServiceApi.get(url);
  },
  getAgentCommissionById: (params) => {
    const url = `${baseServiceUrl}/GetAgentCommission`;
    return ServiceApi.get(url, { params });
  },
  createAgentCommission: (data) => {
    const url = `${baseServiceUrl}/CreateAgentCommission`;
    return ServiceApi.post(url, data, { headers });
  },
  editAgentCommission: (data) => {
    const url = `${baseServiceUrl}/EditAgentCommission`;
    return ServiceApi.post(url, data, { headers });
  },
};

export default ApiAgentCommission;


